<template>
  <div class="label-custom">
     <div v-if="type == 'premium'" class="label-premium">
      <div class="wrapper">
        <div class="label" :style="getFontColor(color)">{{label}}</div>
        <div class="icon"><img  class="image" src="/img/icons/ic-premium.png" alt=""></div>
      </div>
    </div>
    <div v-if="type == 'custom-label-v2'" class="status-label">
      <div class="label-v2" :style="getLabelStyle(labelStyle)">
        {{label}} 
      </div>
    </div>
    <div v-else class="status-label">
      <div class="label" :style="getColor(color)">
        {{label}} 
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'adx-status-label-custom',
  components: {

  },
  props: {
    label: {
      required: false
    },
    color:{
      required: false
    },
    labelStyle:{
      type: Object,
      default: () => {
        return {
          bgColor: '#ffd4dc',
          color: '#e02020',
          borderColor : '#e02020'
        }
      }
    },
    type: {
      required: false,
      default: null
    }
  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getColor(color){
      return {
        "background-color": color
      }
    },
    getFontColor(color){
      return {
        "color": color
      }
    },
    getLabelStyle(labelStyle){
      return {
        "background-color" : labelStyle.bgColor,
        "color" : labelStyle.color,
        "border" : `1px solid ${labelStyle.borderColor}`
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>